module.exports = __webpack_public_path__ + "static/img/minicon4.3ae05049.png";